module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLight.2b2d02d.woff";